import AddIcon from '@mui/icons-material/Add';
import { Button, Stack, Typography, useTheme } from '@mui/material';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { SyncButton } from '../../../component/button/SyncButton';
import { BasicDialog, useNewDialogState } from '../../../component/dialog';
import { useBikeleasingPrecondition } from './useBikeleasingPrecondition';
import { useBikeleasingLatestSyncedCondition, useBikeleasingTenantSyncMutation } from './useBikeleasingSync';

export const AddBikeleasingConditionMenu: React.FC = () => {
  const { t } = useTranslation('benefitsModule');
  const theme = useTheme();
  const { dialogState, handleOpen } = useNewDialogState();
  const { PreconditionComponent, isPreconditionMet } = useBikeleasingPrecondition(dialogState.handleClose);
  const sync = useBikeleasingTenantSyncMutation();
  const latestCondition = useBikeleasingLatestSyncedCondition();

  return isPreconditionMet ? (
    <Stack direction="row" spacing={1}>
      <BasicDialog maxWidth="md" title={t('BIKELEASING.addCondition')} dialogState={dialogState} content={PreconditionComponent} />
      <Stack spacing={1}>
        <SyncButton
          isLoading={sync.isLoading}
          dataTestId="bikeleasing-sync-now"
          onClick={sync.syncBikeleasingTenant}
          lastSyncedAt={latestCondition?.lastSyncedAt}
        />
        {latestCondition && latestCondition.lastSyncedAt && (
          <Typography color={latestCondition.syncError ? theme.palette.warning.light : 'text.secondary'} variant="body2">
            <Trans i18nKey="benefitsModule:BIKELEASING.lastSync" values={{ date: new Date(latestCondition.lastSyncedAt) }} />
          </Typography>
        )}
      </Stack>
      <Button startIcon={<AddIcon />} onClick={handleOpen}>
        {t('BIKELEASING.addCondition')}
      </Button>
    </Stack>
  ) : null;
};
